import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { wrapper, animatedCircle } from './styles.js';

var _excluded = ["children", "visible", "color", "slide"];
var AnimatedCircle = function AnimatedCircle(_ref) {
  var children = _ref.children,
    visible = _ref.visible,
    color = _ref.color,
    slide = _ref.slide,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(wrapper, _extends({
    "data-testid": "elemental-AnimatedCircle",
    $slide: slide,
    $color: color
  }, props), children, /*#__PURE__*/React.createElement(animatedCircle, {
    viewBox: "0 0 44 44",
    $visible: visible
  }, /*#__PURE__*/React.createElement("circle", {
    pathLength: "1",
    strokeWidth: "2",
    cx: "22",
    cy: "22",
    r: "20",
    fill: "none",
    stroke: "currentColor"
  })));
};

export { AnimatedCircle };
